// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ListItemIcon":"bbx_a bhg_kb","ListItemIcon--empty":"bbx_b bhg_fj"};